import Name from './Name';
import AccountGroup from './AccountGroup';
import User from './User';
import Stats from './Stats';
import AccountStatus from './AccountStatus';
import Score from './Score';

export default {
  Name,
  AccountGroup,
  User,
  Stats,
  AccountStatus,
  Score,
};
